import Flux from '../flux';
import Actions from '../actions/addressbookStorageActions.js';

export default Flux.createStore({
	displayName: 'AddressbookStorageStore',
	bindListeners: {
		handleLoadAllAddressbooks: Actions.LOAD_ALL_ADDRESSBOOKS,
		handleSetGlobalPersonalAddressbook: Actions.SET_GLOBAL_PERSONAL_ADDRESSBOOK,
		handleSetLoadingStatus: Actions.SET_LOADING_STATUS,
		handleSetError: Actions.SET_ERROR,
		handleLogActivity: Actions.LOG_ACTIVITY
	},
	state: {
		globalPersonalAddressbook: [],
		
		loading: {
			globalPersonal: false,
			allLoaded: false
		},

		errors: {
			globalPersonal: null
		},
		

		logs: [],

		stats: {
			totalGlobalPersonal: 0,
			lastUpdated: null
		}
	},

	handleLoadAllAddressbooks: function() {
		this.setState({
			loading: {
				globalPersonal: true,
				allLoaded: false
			}
		});
	},

	handleSetGlobalPersonalAddressbook: function(data) {

		const entries = Array.isArray(data) ? data : 
			(data.addressbook || data.list || data.data || []);
		const count = entries.length;
		
		this.setState({
			globalPersonalAddressbook: entries,
			loading: { ...this.state.loading, globalPersonal: false },
			stats: { ...this.state.stats, totalGlobalPersonal: count }
		});
		this.checkAllLoaded();
	},

	handleSetLoadingStatus: function(payload) {
		this.setState({
			loading: { ...this.state.loading, ...payload }
		});
	},

	handleSetError: function(payload) {
		this.log(`Error loading ${payload.type}: ${payload.error}`, 'error');
		this.setState({
			errors: { ...this.state.errors, [payload.type]: payload.error },
			loading: { ...this.state.loading, [payload.type]: false }
		});
		this.checkAllLoaded();
	},

	handleLogActivity: function(message) {
		this.log(message, 'info');
	},

	log: function(message, level = 'info') {
		const timestamp = new Date().toISOString();
		const logEntry = {
			timestamp,
			level,
			message,
			id: Date.now() + Math.random()
		};
		
		const newLogs = [...this.state.logs, logEntry];
		if (newLogs.length > 100) {
			newLogs.shift();
		}
		
		this.setState({ logs: newLogs });
		
		const consoleMsg = `[AddressbookStorage] ${timestamp} - ${message}`;
		switch(level) {
			case 'error':
				console.error(consoleMsg);
				break;
			case 'warn':
				console.warn(consoleMsg);
				break;
			case 'success':
				console.log(`✅ ${consoleMsg}`);
				break;
			default:
				console.log(consoleMsg);
		}
	},

	checkAllLoaded: function() {
		const { loading } = this.state;
		const allLoaded = !loading.globalPersonal;
		
		if (allLoaded && !this.state.loading.allLoaded) {
			this.setState({
				loading: { ...loading, allLoaded: true },
				stats: { ...this.state.stats, lastUpdated: new Date().toISOString() }
			});
			
			const { stats } = this.state;
		}
	},


	getGlobalPersonalAddressbook: function() {
		return this.state.globalPersonalAddressbook;
	},

	getAllAddressbooks: function() {
		return {
			globalPersonal: this.state.globalPersonalAddressbook
		};
	},

	getStats: function() {
		return this.state.stats;
	},

	getLogs: function() {
		return this.state.logs;
	},

	isAllLoaded: function() {
		return this.state.loading.allLoaded;
	},

	isLoading: function() {
		const { loading } = this.state;
		return loading.globalPersonal;
	},

	getErrors: function() {
		return this.state.errors;
	}
}); 